interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, actionLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">{title}</h2>
        {desc ? <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p> : null}
      </div>
      {actionLabel ? (
        <a
          href="#subscribe"
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition hover:border-primary-400 hover:text-primary-700 cursor-pointer"
        >
          {actionLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </a>
      ) : null}
    </div>
  );
}